module.exports = __webpack_public_path__ + "img/album21_33.a1032eb0.jpg";